<template>

  <div>
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('pages.adminpanel.classes.bannerName')}}</h3>
        <div class="btn-group pull-right">
          <button v-if="autoEnroll" type="button" class="btn btn-danger createBtn" @click.prevent="editAutoEnroll(null)">
            <i class="fa fa-minus-square-o icon"></i> {{$t('pages.adminpanel.classes.autoEnrollDisable')}}
          </button>
          <button v-else-if="!autoEnroll" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{$t('pages.adminpanel.classes.autoEnrollEnable')}}
            <span class="fa fa-caret-down"></span>
          </button>
          <ul class="dropdown-menu">
            <li v-for="cl in classes" v-bind:key="cl.id">
              <a href="#" v-if="cl.id != null" @click.prevent="editAutoEnroll(cl.id)">{{cl.name}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div v-for="cl in classes" v-bind:key="cl.id">
        <!-- <div class="box" :name="cl.id" :class="[{ grayout: autoEnroll && cl.id == null}, { 'collapsed-box': autoEnroll && cl.id == null}]"> -->
        <div class="box" :name="cl.id" v-if="cl.id != null || cl.enrollments.length > 0">
          <div class="box-header with-border">
            <h3 class="box-title">
              <input v-if="cl.id != null" :ref="'title' + cl.id" type="text" name="title" v-model="cl.name" @input="changeName(cl)">
              <span v-else>{{$t('pages.adminpanel.classes.awaiting')}}</span>
              <div v-if="autoEnroll && autoEnroll == cl.id" class="badge bg-blue">{{$t('pages.adminpanel.classes.defaultClass')}}</div>
            </h3>
            <div class="box-tools pull-right">
              <div class="btn-group">
                <button class="btn btn-box-tool" @click.prevent="exportCSV(cl.id)">
                    CSV <i class="fa fa-download"></i>
                </button>
                  <button @click.prevent="downloadUserRating(cl.id)" class="btn btn-sm btn-box-tool">
                  {{$t('pages.adminpanel.classes.exportUserRatingForClass')}} <i class="fa fa-download"></i>
                </button>
                <button class="btn btn-box-tool" @click.prevent="openImport(cl.id)">
                    <i class="fa fa-upload"></i>
                  </button>
                  <button v-if="cl.id != null" type="submit" @click.prevent="toggleModalForDeletion(cl)" class="btn btn-box-tool">
                    <i class="fa fa-trash"></i>
                  </button>
                  <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead class="exercise-header">
              
              </thead>
              <tbody>
                <tr>
                  <th>{{$t('pages.adminpanel.classes.tableId')}}</th>
                  <th>{{$t('pages.adminpanel.classes.tableUser')}}</th>
                  <th>{{$t('pages.adminpanel.classes.tableStudentId')}}</th>
                  <th>{{$t('pages.adminpanel.classes.tableDate')}}</th>
                  <th></th>
                </tr>
                <tr v-for="usr in cl.enrollments"> 
                  <td>{{usr.id}}</td> 
                  <td> 
                    <a @click.prevent="">{{usr.user.firstName}} {{usr.user.lastName}}</a> 
                  </td> 
                  <td>{{usr.user.studentId}}
                  <td>{{usr.createdAt.substring(0,4)}}</td> 
                  <td class="pull-right">
                    <div class="btn-group over-border">
                      <button v-if="cl.name == 'Default' "type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{$t('pages.adminpanel.classes.confirm')}}
                          <span class="fa fa-caret-down"></span></button>
                      <button v-else type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="true">{{$t('pages.adminpanel.classes.move')}}
                          <span class="fa fa-caret-down"></span></button>
                        <ul class="dropdown-menu" style="position:absolute;" role="menu">
                          <li v-for="cl2 in classes" :key="cl2.id"><a href="#" v-if="cl2.name != cl.name && cl2.id" @click.prevent="moveUser(cl2, usr)">{{cl2.name}}</a></li>
                        </ul>
                    </div>
                      <button type="submit" @click.prevent="toggleModalForDeletionEnrollment(usr)" class="btn btn-danger">
                        <i class="fa fa-trash"></i>
                      </button>
                  </td>
                </tr> 
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
      <div class="box">
        <button type="button" class="btn btn-default btn-block" @click.prevent="addClass()">
          <div class="pull-left text">
            {{$t('pages.adminpanel.classes.createClass')}}
          </div>
          <button class="btn btn-box-tool pull-right">
            <i class="fa fa-plus"></i>
          </button>
        </button>
      </div>

      <div class="modal modal-danger fade" id="modal-delete">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">{{$t('pages.adminpanel.classes.deleteClass')}}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>{{$t('pages.adminpanel.classes.confirmation')}}</p>
                <small>{{$t('pages.adminpanel.classes.toDefault')}}</small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.classes.cancel')}}</button>
              <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="deleteClass()">{{$t('pages.adminpanel.classes.confirm')}}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <div class="modal modal-danger fade" id="modal-delete-enrollment">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">{{$t('pages.adminpanel.classes.deleteEnrollment')}}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>{{$t('pages.adminpanel.classes.confirmation2')}}</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.classes.cancel')}}</button>
              <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="deleteEnrollment()">{{$t('pages.adminpanel.classes.confirm')}}</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- MODAL FOR STRUCTURE IMPORT -->
      <div class="modal modal-default fade" :id="'importCSV'">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">Import users with CSV</h4>
            </div>
            <div class="modal-body">
              <template>
                <form class="uploadForm" enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                  <div class="dropbox">
                    <input type="file" name="file" :disabled="isSaving" @change="save(); fileCount = $event.target.files.length" accept=".csv" class="input-file">
                    <p v-if="isInitial">
                      Please drag and drop a .csv file<br> or click here
                    </p>
                    <p v-if="isSaving">
                      <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
                    </p>
                  </div>
                </form>
              </template>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    </div>
  </div>
</template>

<script>
  // import router from './../../router/router'
  import Rest from './../../../services/rest'
  import { mapState } from 'vuex'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  // const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3
  import { saveAs } from 'file-saver/FileSaver'
  let moment = require('moment')

  export default {
    data () {
      return {
        classes: [],
        newName: '',
        updated: false,
        selectedClass: '',
        selectedStudent: {},
        autoEnroll: '',
        cid: ''
      }
    },
    props: {
      gid: String,
      yid: String
    },
    computed: {
      ...mapState({
        me: state => state.userData
      }),
      disable: function () {
        return 'grayout'
      },
      isInitial () {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      }
    },
    methods: {
      exportCSV (classId) {
        console.log('Downloaded')
        let resultCSV = 'Number,Firstname,Surname,Student number,EnrolledAt\n'
        // resultCSV.push([
        //   'Number,Firstname,Surname,Student number,EnrolledAt\n'
        // ])
        let i = 0
        for (let classInstance of this.classes) {
          if (classInstance.id === classId) {
            for (let enrollemnt of classInstance.enrollments) {
              console.log(enrollemnt)
              resultCSV += `${i++},${enrollemnt.user.firstName},${enrollemnt.user.lastName},${enrollemnt.user.studentId},${moment(enrollemnt.createdAt).format('YYYY-MM-DD HH:mm')}\n`
            }
          }
        }
        var blob = new Blob([resultCSV], {type: 'text/csv;charset=utf-8'})
        saveAs(blob, 'uporabniki.csv')
      },
      downloadUserRating (classId) {
        return Rest.requestForm('GET', '/rating/groups/' + this.gid + '/classes/' + classId + '/userRatingExport').then((data) => {
          if (!data.message) {
            console.log(data)
            var blob = new Blob([data], {type: 'text/csv;charset=utf-8'})
            saveAs(blob, 'student_rating.csv')
          } else {
            Rest.Vue.$snotify.error(this.$t('alerts.results'), this.errorThrown)
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      prepareComponent () {
        this.$store.dispatch('getGroup', {
          gid: this.gid,
          yid: this.yid,
          sid: 'root'
        })
        this.$store.commit('updateAdminBreadcrumbs', [{path: 'classes', name: {'en-us': 'Classes', sl: 'Razredi'}}])
        this.getClasses()
        this.reset()
      },
      changeName (cl) {
        this.selectedClass = cl
        this.newName = cl.name
      },
      getClasses () {
        var tren = this
        return Rest.request('GET', '/years/' + this.yid + '/users').then(function (data) {
          tren.classes = data.classes
          tren.autoEnroll = data.autoEnrollClassId
        }).catch(function (err) {
          console.log(err)
        })
      },
      moveUser (cl, usr) {
        let tren = this
        let putdata = {
          classId: cl.id
        }
        return Rest.request('PUT', '/enrollments/' + usr.id, putdata).then(function (data) {
          tren.getClasses()
        }).catch(function (err) {
          console.log(err)
        })
      },
      deleteEnrollment () {
        return Rest.request('DELETE', '/enrollment/' + this.selectedStudent.id).then(data => {
          this.getClasses()
        }).catch(function (err) {
          console.log(err)
        })
      },
      toggleModalForDeletionEnrollment (usr) {
        console.log('NEKI')
        this.selectedStudent = usr
        window.jQuery('#modal-delete-enrollment').modal('toggle')
      },
      addClass () {
        let postdata = {
          yearId: this.yid,
          name: 'New Class ' + this.yid + moment().format('ssSS')
        }
        Rest.request('POST', '/classes', postdata).then(data => {
          this.classes.push(data)
          this.$nextTick(function () {
            this.$refs['title' + data.id][0].focus()
          })
        }).catch(function (err) {
          console.log(err)
        })
      },
      deleteClass () {
        // metoda izbrise razred, uporabnike v razredu pa premakne v razred default
        let deletedata = {
          force: true
        }
        return Rest.request('DELETE', '/classes/' + this.selectedClass.id, deletedata).then(data => {
          console.log(data)
          this.getClasses()
        }).catch(function (err) {
          console.log(err)
        })
      },
      toggleModalForDeletion (cl) {
        this.selectedClass = cl
        window.jQuery('#modal-delete').modal('toggle')
      },
      editAutoEnroll (id) {
        if (!id) {
          id = 'null'
        }
        let putdata = {
          autoEnrollClassId: id
        }
        return Rest.request('PUT', '/years/' + this.yid, putdata).then(data => {
          if (id === 'null') this.autoEnroll = null
          else this.autoEnroll = id
        }).catch(function (err) {
          console.log(err)
        })
      },
      openImport (cid) {
        this.cid = cid
        window.jQuery('#importCSV').modal('toggle')
      },
      save () {
        // upload data to the server
        this.currentStatus = STATUS_SAVING
        let formData = new FormData(window.jQuery('.uploadForm')[0])
        if (formData) {
          return Rest.requestForm('POST', '/classes/Insert/' + this.cid + '/' + this.yid, formData).then(x => {
            this.reset()
            this.uploadedFiles = [].concat(x)
            // this.currentStatus = STATUS_SUCCESS
            window.jQuery('#importCSV').modal('toggle')
            window.jQuery('#importCSV').find('input:file').val('')
            this.prepareComponent()
            alert('Users sucessfully added')
          }).catch(err => {
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
            window.jQuery('#importStructure').modal('toggle')
            window.jQuery('#importCSV').find('input:file').val('')
            alert(((err.responseJSON && err.responseJSON.message) ? ('\n' + err.responseJSON.message) : ('')))
            this.reset()
          })
        }
      },
      reset () {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.uploadedFiles = []
        this.uploadError = null
        this.cid = ''
      }
    },
    subscriptions () {
      return {
        changeClassName: this.$watchAsObservable('newName').map((val) => val.newValue)
        .do({
          next: () => {
            this.updated = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            console.log(this.newName)
            let putdata = {
              name: this.newName
            }
            return Rest.request('PUT', '/classes/' + this.selectedClass.id, putdata).then(function (data) {
              console.log(data)
            }).catch(function (err) {
              console.log(err)
            })
          }
        })
      }
    },
    created () {
      this.prepareComponent()
    },
    mounted () {
    },
    components: {
      'pulse-loader': PulseLoader
    }
  }
</script>

<style scoped>
#addRole:hover {
  cursor: pointer;
}

.exercise-header {
  margin-bottom: 1em;
}

.over-border {
  position: absolute;
  right: 4em;
}

input[type="text"]
{
  background: transparent;
  border: none;
}

input[type="text"]:hover {
  border: 1px solid #999;
  color: #000;
}

.table-responsive {
  overflow-y: visible !important;
  overflow-x: hidden;
}

.btn-block {
  background-color: white;
}

.text {
  font-size: 1.3em;
}

.grayout {
  opacity: 0.6;
  filter: alpha(opacity = 60);
  cursor: not-allowed;
  pointer-events:none;
}

</style>



// WEBPACK FOOTER //
// Classes.vue?824ce48c